/**
 * Debug logger that only logs when debugSkagenWeb cookie is set
 * Also sends logs to backend for Kibana integration
 */

import axios from 'axios';

function hasDebugCookie(): boolean {
    return document.cookie.split(';').some((cookie: string) =>
        cookie.trim().startsWith('debugSkagenWeb=')
    );
}

function getAntiForgeryToken(): string | null {
    const meta = document.querySelector('meta[name="RequestVerificationToken"]');
    return meta ? meta.getAttribute('content') : null;
}

async function sendToBackend(level: string, args: unknown[]): Promise<void> {
    try {
        const message = args
            .map(arg =>
                typeof arg === 'object' ? JSON.stringify(arg) : String(arg)
            )
            .join(' ');

        const token = getAntiForgeryToken();
        await axios.post(
            '/api/clientlog',
            {
                level,
                message
            },
            {
                headers: {
                    RequestVerificationToken: token
                }
            }
        );
    } catch (error) {
        // Silent fail - don't break app if logging fails
        console.error('Failed to send log to backend:', error);
    }
}

interface Logger {
    debug(...args: unknown[]): void;
    error(...args: unknown[]): void;
    warn(...args: unknown[]): void;
    info(...args: unknown[]): void;
}

export const logger: Logger = {
    debug(...args: unknown[]): void {
        if (hasDebugCookie()) {
            console.log(...args);
        }
        sendToBackend('debug', args);
    },
    error(...args: unknown[]): void {
        if (hasDebugCookie()) {
            console.error(...args);
        }
        sendToBackend('error', args);
    },
    warn(...args: unknown[]): void {
        if (hasDebugCookie()) {
            console.warn(...args);
        }
        sendToBackend('warn', args);
    },
    info(...args: unknown[]): void {
        if (hasDebugCookie()) {
            console.info(...args);
        }
        sendToBackend('info', args);
    }
};
